import React from 'react';
import { useTheme } from '../theme/ThemeContext';

const Title = ({title, des}) => {
  const {darkTheme} = useTheme();
  return (
    <div className="flex flex-col gap-4 font-titleFont mb-14">
      <h3 className={darkTheme?"text-sm uppercase font-light text-designColor tracking-wide"
      :"text-black uppercase font-light text-black tracking-wide"}>
       {title}
      </h3>
      <h1 className={darkTheme?"text-4xl md:text-5xl text-gray-300 font-bold capitalize":
    "text-black md:text-5xl text-black-300 font-bold capitalize"}>{des}</h1>
    </div>
  );
}

export default Title